import { SimpleGrid, Text } from "@mantine/core";

import { RegisterCard } from "@prostocheck/controls-web";

import { IBusinessUnitGroupProps } from "./business-unit-group.models";

export const BusinessUnitGroup = ({
  name,
  address,
  registers,
  isLoading,
}: IBusinessUnitGroupProps) => (
  <section>
    <div className="mb-4">
      <h2 className="text-lg font-semibold text-ink-900">{name}</h2>
      <Text size="sm" c="dimmed">
        {address}
      </Text>
    </div>

    <SimpleGrid cols={{ base: 1, lg: 2 }} spacing="md">
      {registers.map(register => (
        <RegisterCard
          key={register.fiscalNumber}
          register={register}
          isLoading={isLoading}
        />
      ))}
    </SimpleGrid>
  </section>
);
